module.exports = __webpack_public_path__ + "img/playing.fab3f5e3.png";